var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],attrs:{"element-loading-text":"正在跳转到首页"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }